import { Component, Input } from '@angular/core';

@Component({
  selector: 'ca-count-comparison-card',
  templateUrl: './count-comparison-card.component.html',
  styleUrls: ['./count-comparison-card.component.scss'],
})
export class CaCountComparisonCardComponent {
  Infinity = Infinity;
  @Input()
  title: string;

  // If provided, a subtitle will override the comparison indicator to the previous average
  @Input()
  subtitle: string;

  @Input()
  average: number;
  @Input()
  previousAverage?: number;
  @Input()
  worst: number;
  @Input()
  best: number;

  @Input()
  type?: 'duration-ms' | 'count';

  // A translation string for what the average represents. E.g. "Posts", "Memoriams".
  @Input()
  typeTranslation?: string;

  // Whether to display an uptick in the comparison as green or red.
  @Input()
  fewerIsPreferred?: boolean;
}
